// src/api/socket.ts
import { io, Socket } from 'socket.io-client';

const API_BASE: string = (process.env.REACT_APP_API_BASE || 'http://localhost:5000').replace(/\/$/, '');

let socket: Socket | null = null;

export function getSocket(): Socket | null {
    return socket;
}

export function connectSocket(): Socket {
    if (socket) {
        if (!socket.connected) socket.connect();
        return socket;
    }

    const token = localStorage.getItem('token');
    if (!token) throw new Error('No auth token');

    socket = io(API_BASE, {
        auth: { token },
        transports: ['websocket', 'polling'],
        reconnection: true,
        reconnectionAttempts: 10,
        reconnectionDelay: 1000,
    });

    socket.on('connect', () => {
        console.log('Socket connected:', socket?.id);
    });

    socket.on('connect_error', (err) => {
        console.error('Socket connection error:', err.message);
    });

    socket.on('disconnect', (reason) => {
        console.log('Socket disconnected:', reason);
    });

    return socket;
}

export function disconnectSocket(): void {
    if (socket) {
        socket.disconnect();
        socket = null;
    }
}
